import { Anchor, StandardCard } from "@newsela/angelou";
import PropTypes from "prop-types";

import SortableDeckOfCards from "@/assignments/AssignmentEditor/SortableDeckOfCards";
import {
  activityCardCss,
  footerCss,
  footerViewLinkCss,
} from "./ActivityCard.style";

const propTypes = {
  /**
   * Activity object with required props to show the card
   */
  activity: PropTypes.shape({
    /**
     * Activity's id
     */
    id: PropTypes.number,
    /**
     * Type of activity like write prompt, quiz
     */
    activityType: PropTypes.string,
    /**
     * Activity's name
     */
    name: PropTypes.string,
    /**
     * Subject like ELA, Science, etc.
     */
    subject: PropTypes.string,
    /**
     * Activity's description
     */
    text: PropTypes.string,
    /**
     * Collection Id for this activity
     */
    collection: PropTypes.number,
  }),
  /**
   * Assignment's content (article, video, audio) URL
   */
  contentViewUrl: PropTypes.string,
};

/**
 * Actually, the view activity link works well with `quiz, write prompt and lesson-sparks`.
 * But, we should consider to include the activity view url from backend.
 *
 * @param contentViewUrl
 * @param activityType
 * @param collection
 * @returns {JSX.Element}
 * @constructor
 */
const CardFooter = ({ contentViewUrl, activityType, collection }) => {
  return (
    <div css={footerCss}>
      <Anchor
        ariaProps={{
          "aria-label": "View activity. Link opens in a new tab",
        }}
        href={`${contentViewUrl}/${activityType}?preview_for=assignment&collection=${collection}`}
        __cssFor={{
          root: footerViewLinkCss,
        }}
        openInNewTab
      >
        View
      </Anchor>
    </div>
  );
};
CardFooter.propTypes = {
  contentViewUrl: PropTypes.string,
  activityType: PropTypes.string,
  collection: PropTypes.number,
};

const ActivityCard = (props) => {
  const { activity, contentViewUrl } = props;
  return (
    <SortableDeckOfCards.Item key={activity?.id} id={activity?.id}>
      <StandardCard
        __css={activityCardCss}
        key={activity?.id}
        id={activity?.id}
        title="-"
        titleLineNum={0}
        description={activity.text}
        contentType={`Activity: ${activity.subject} ${activity.name}`}
        footer={<CardFooter contentViewUrl={contentViewUrl} {...activity} />}
      />
    </SortableDeckOfCards.Item>
  );
};

ActivityCard.propTypes = propTypes;
export default ActivityCard;
